import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        checkIconBox: {
            backgroundColor: 'text.success',
            border: 'large',
            borderColor: 'text.success',
            borderRadius: 'full',
            alignSelf: 'center',
            borderStyle: 'solid',
            boxSize: 'iconsSize.xlarge',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        checkIcon: {
            boxSize: 'iconsSize.xlarge',
            color: 'text.inverse',
        },
        confirmationContainer: {
            backgroundColor: 'background.default',
            gap: remCalc(0),
        },
        marginContainer: {
            layerStyle: 'full-width',
            width: '100%',
            margin: {base: '0', lg: '0 auto'},
        },
        gapStack: {
            gap: {base: remCalc(24), md: remCalc(40)},
        },
        thankYouContainer: {
            display: 'grid',
            gap: {base: 0, lg: remCalc(24)},
        },
        thankYouStack: {
            gap: remCalc(24),
        },
        orderNumberDate: {
            gap: remCalc(8),
        },
        textThanks: {
            w: 'full',
            gap: remCalc(40),
            alignItems: 'center',
            textAlign: 'center',
            paddingY: remCalc(24),
            paddingX: {base: remCalc(16), md: remCalc(24)},
        },
        textThankYou: {
            textStyle: 'body-large',
            color: 'text.default',
        },
        confirmationText: {
            textStyle: 'body-small',
            color: 'text.default',
        },
        orderNumber: {
            textStyle: 'body-xlarge',
            color: 'text.default',
        },
        orderDate: {
            textStyle: 'body-xsmall',
            color: 'text.default',
        },
        continueShoppingButton: {
            maxWidth: {base: 'full', lg: remCalc(310)},
            w: {base: 'full', lg: 'inherit'},
        },
        footerConfirmation: {
            alignItems: 'center',
            w: 'full',
            gap: remCalc(24),
            marginTop: {lg: remCalc(40)},
            marginBottom: {sm: remCalc(24), md: remCalc(80)},
        },
        orderSummaryHeader: {
            justifyContent: 'space-between',
            gap: remCalc(16),
            padding: `${remCalc(12)} 0`,
        },
        orderSummaryItem: {
            backgroundColor: 'background.light',
            p: remCalc(24),
            gap: 0,
        },
        orderSummaryTitle: {
            textStyle: 'body-large',
            color: 'text.default',
            fontWeight: 'bold',
        },
        orderSummaryHeadings: {
            textStyle: 'body-large',
            color: 'text.default',
            fontWeight: 'medium',
        },
        orderSummaryText: {
            textAlign: 'left',
        },
        products: {
            gap: remCalc(24),
            w: 'full',
            p: remCalc(24),
            alignItems: 'flex-start',
        },
        productItem: {
            width: 'full',
            alignItems: 'flex-start',
            gap: remCalc(24),
            borderBottom: 'small',
            borderColor: 'border.light',
            borderStyle: 'solid',
            paddingBottom: remCalc(24),
        },
        productImage: {
            boxSize: remCalc(109),
        },
        productName: {
            textStyle: 'body-medium',
            color: 'text.default',
        },
        quantity: {
            textStyle: 'body-xsmall',
            color: 'text.default',
        },
        priceQuantity: {
            gap: remCalc(4),
            alignItems: 'flex-start',
        },
        productItemDetails: {
            alignItems: 'flex-start',
            gap: remCalc(16),
        },
        orderSummaryDetails: {
            w: 'full',
            gap: remCalc(16),
        },
        shipmentBilling: {
            flexDirection: {base: 'column', lg: 'row'},
            backgroundColor: 'background.light',
            padding: `${remCalc(24)} 0`,
            gap: remCalc(24),
            justifyContent: 'space-between',
        },
        category: {
            padding: {base: '0 16px', lg: '0px 16px 0px 24px'},
            alignItems: 'flex-start',
            gap: {base: remCalc(16), lg: remCalc(24)},
            flex: 1,
        },
        payment: {
            padding: '0px 16px',
            alignItems: 'flex-start',
            gap: {base: remCalc(16), lg: remCalc(24)},
            flex: 1,
        },
        summary: {
            padding: {base: '0 16px', lg: '0px 24px 0px 16px'},
            alignItems: 'flex-start',
            gap: {base: remCalc(16), lg: remCalc(24)},
            flex: 1,
        },
        addressCard: {
            padding: '24px 20px 20px 20px',
            alignItems: 'flex-start',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            backgroundColor: 'background.default',
            w: 'full',
            gap: remCalc(16),
        },
        orderSummaryPrices: {
            gap: remCalc(4),
            w: 'full',
        },
        pricing: {
            p: '12px 0',
            justifyContent: 'space-between',
            textStyle: 'body-small',
            color: 'text.default',
        },
        pricingTotal: {
            gap: remCalc(4),
            p: '16px 0',
            justifyContent: 'space-between',
            textStyle: 'body-large',
            color: 'text.default',
            fontWeight: 'bold',
            textAlign: 'left',
        },
        addressDisplay: {
            textAlign: 'left',
        },
        addressShippingCard: {
            textStyle: 'body-medium',
            color: 'text.default',
            gap: remCalc(4),
            textAlign: 'left',
        },
        addressShippingName: {
            fontWeight: 'bold',
        },
        freeShipping: {
            color: 'text.success',
        },
        deliveryStandard: {gap: remCalc(8), w: 'full'},
        deliveryNamePrice: {justifyContent: 'space-between'},
        infoIcon: {
            boxSize: ['iconsSize.small', 'iconsSize.small', 'iconsSize.small', 'iconsSize.small'],
            fill: 'background.light',
            color: 'button.text.secondary-default',
            cursor: 'default',
            borderColor: 'button.text.secondary-default',
        },
        textInfoIcon: {gap: remCalc(8)},
        underlined: {
            textDecoration: 'underline',
        },
        xsmallText: {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            textAlign: 'left',
        },
        promotionApplied: {
            justifyContent: 'space-between',
            fontSize: remCalc(14),
        },
    },
}
